import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';

import GRTabIcon from './GRTabIcon';
import selectGRTabIconProps from './GRTabIcon.selector';

type GRTabIconContainerProps = {
  className?: string;
  disableAnimation?: boolean;
  isHighlight?: boolean;
};

const GRTabIconContainer = (ownProps: GRTabIconContainerProps) => {
  const selectedProps = useSelector(selectGRTabIconProps);

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <GRTabIcon {...enhancedProps} />;
};

export default GRTabIconContainer;
